import { Box, type SelectChangeEvent } from '@mui/material'
import { type ITabOption, Tabs } from 'components'
import { color } from 'config/color'
import { type Dispatch, type SetStateAction, useEffect, useState } from 'react'
import { CampaignList, CreateNewCampaign, CampaignLogs } from './components'
import { isEmpty } from 'lodash'
import { useLocation, useNavigate } from 'react-router-dom'
import { ROUTES_PATH } from 'config'

const getCampaignTabOptions = (
  campaignId: string,
  setActiveTab: Dispatch<SetStateAction<number>>
): ITabOption[] => [
  {
    title: 'Campaigns',
    content: <CampaignList setActiveTab={setActiveTab} />
  },
  {
    title: 'Create New Campaign',
    content: (
      <CreateNewCampaign campaignId={campaignId} setActiveTab={setActiveTab} />
    )
  }
]

export const Campaigns: React.FC = () => {
  const [activeTab, setActiveTab] = useState<number>(0)
  const [campaignId, setCampaignId] = useState('')

  const location = useLocation()
  const navigate = useNavigate()

  const handleTabChange = (_e: any, newActiveTab: number): void => {
    setCampaignId('')
    navigate(ROUTES_PATH.CAMPAIGNS)

    setActiveTab(newActiveTab)
  }
  const handleSelectChange = (event: SelectChangeEvent): void => {
    setCampaignId('')
    navigate(ROUTES_PATH.CAMPAIGNS)
    setActiveTab(Number(event.target.value))
  }

  useEffect(() => {
    if (!isEmpty(location.search)) {
      const query = new URLSearchParams(location.search)
      setCampaignId(query.get('id') ?? '')
      setActiveTab(ROUTES_PATH.CAMPAIGN_LOGS === location.pathname ? 0 : 1)
    } else {
      setActiveTab(0)
      setCampaignId('')
    }
  }, [location.pathname, location.search])

  return (
    <Box mt={5} bgcolor={color.white}>
      {ROUTES_PATH.CAMPAIGN_LOGS === location.pathname
      ? (
        <CampaignLogs setActiveTab={setActiveTab}/>
      )
      : (
        <Tabs
          activeTab={activeTab}
          handleTabChange={handleTabChange}
          handleSelectChange={handleSelectChange}
          tabOptions={getCampaignTabOptions(campaignId, setActiveTab)}
          isVisible={isEmpty(campaignId) || activeTab === 0}
        />
      )}
    </Box>
  )
}
